import React, { useRef, useState } from 'react';
import { ASK_COPY, composerKeyAction } from '../../utils/askScope';

const MAX_ROWS = 5;

// Docked composer. Enter sends, Shift+Enter is a newline, Escape blurs. Cancel shows only while a
// turn is working and says plainly that it only stops waiting (AC 80). `depthControl` is the
// existing depth selector, passed in as a node. Presentational: onSend(text) / onCancel() only.
export default function AskComposer({ onSend, onCancel, working, depthControl, placeholder, initialText }) {
  // initialText prefills the box (a question redirected from Build); it is never sent for you.
  const [text, setText] = useState(typeof initialText === 'string' ? initialText : '');
  const ref = useRef(null);
  const rows = Math.min(MAX_ROWS, Math.max(1, text.split('\n').length));
  const canSend = !working && text.trim() !== '';

  const send = () => {
    if (!canSend || typeof onSend !== 'function') return;
    const value = text.trim();
    setText('');
    onSend(value);
    if (ref.current && typeof ref.current.focus === 'function') ref.current.focus();
  };

  const onKeyDown = (e) => {
    const action = composerKeyAction(e);
    if (action === 'blur') {
      if (ref.current) ref.current.blur();
    } else if (action === 'send') {
      e.preventDefault();
      send();
    }
  };

  return (
    <div className="ask-composer">
      <textarea
        ref={ref}
        className="ask-composer-input"
        aria-label="Ask a question"
        rows={rows}
        value={text}
        placeholder={placeholder || 'Ask about this capture'}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={onKeyDown}
      />
      <div className="ask-composer-row">
        {depthControl || null}
        {working ? (
          <>
            <button type="button" className="ask-btn" title={ASK_COPY.cancelTitle} onClick={onCancel}>Cancel</button>
            <span className="ask-muted-note">{ASK_COPY.cancelHelp}</span>
          </>
        ) : null}
        <button type="button" className="ask-btn ask-btn--primary" disabled={!canSend} onClick={send}>Send</button>
      </div>
    </div>
  );
}
